<template>
  <v-card class="pa-4" elevation="2">
    <v-card-title class="d-flex justify-space-between align-center">
      <div>
        <span class="text-h6">Ajuste</span>
        <span class="mx-2 primary--text text-h6">{{ item.item_name }}</span>
        <span class="text-h6">{{ formattedAmount }}</span>
      </div>
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="item.item_description"
      
            label="Cambiar Descripcion"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="item.note"
            label="Nota"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center" class="mb-4">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="item.accountable"
            label="Editar contabilidad"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn
            v-if="item.accountable"
            color="primary"
            outlined
            @click="addLine"
            class="mt-2 mt-sm-0"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar línea
          </v-btn>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div v-if="item.accountable">
          <v-card outlined class="mb-4">
            <v-card-text>
              <div class="d-flex justify-space-between align-center mb-4">
                <span class="text-h6">Consumido</span>
                <span
                  :class="[
                    'text-h6',
                    totCont.totalAmount == item.amount ? 'success--text' : 'error--text'
                  ]"
                >
                  {{ currencyFormat(totCont.totalAmount) }}
                </span>
              </div>

              <v-data-table
                :headers="headers_account"
                :items="accounts_computed"
                :items-per-page="10 "
                
                show-expand
                :single-expand="true"
                :expanded.sync="expanded"
                item-key="id"
                class="elevation-1"
              >
                <template v-slot:item.chart_of_account_id="{ item }">
                  <v-autocomplete
                    v-model="item.chart_of_account_id"
                    :items="accounts"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    @change="updateDgiiCategory(item)"
                    label="Cuenta contable"
                  ></v-autocomplete>
                </template>

                <template v-slot:item.location="{ item }">
                  <v-autocomplete
                    v-model="item.location_id"
                    :items="locations"
                    dense
                    outlined
                    hide-details
                    label="Location"
                  ></v-autocomplete>
                </template>

                <template v-slot:item.amount="{ item }">
                  <v-text-field
                    v-model.number="item.amount"
                    type="number"
                    dense
                    outlined
                    hide-details
                    label="Monto"
                  ></v-text-field>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn icon small @click="deleteItem(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-card flat class="pa-4">
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="item.descripcion"
                            label="Descripción"
                            dense
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="item.dgii_category_id"
                            :items="categoryDgii"
                            label="Categoría DGII"
                            dense
                            outlined
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="item.entity_id"
                            :items="entity"
                            label="Entidad"
                            dense
                            outlined
                            @input="getEntitys"
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    Digita la entidad
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="item.department_id"
                            :items="itemsDepartment"
                            label="Departamento"
                            dense
                            outlined
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="item.diary_book_category_id"
                            :items="categoriesForAccount(categories, item.chart_of_account_id)"
                            @change="item.diary_book_sub_category_id = null"
                            label="Categoría"
                            item-text="name"
                            item-value="id"
                            dense
                            outlined
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="item.diary_book_sub_category_id"
                            :items="filteredSubCategories(item)"
                            label="Sub-Categoría"
                            item-text="name"
                            item-value="id"
                            dense
                            outlined
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-card>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </div>
      </v-expand-transition>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" text @click="close">Cancelar</v-btn>
      <v-btn color="primary" @click="save">Guardar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from "moment";
import accountCategoryRules from "../../mixins/accountCategoryRules";

export default {
  name: 'AccountingAdjustment',
  mixins: [accountCategoryRules],
  
  props: {
    item: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: () => []
    },
    selected_locations: {
      type: Object,
      default: () => ({})
    },
    seleted_currencies: {
      type: [String, Number],
      default: null
    },
    hasDiscount: {
      type: Boolean,
      default: false
    },
    discount_percent_selected: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    date: moment().format("YYYY-MM-DD"),
    expanded: [],
    headers_account: [
      { text: "Cuenta contable", value: "chart_of_account_id" },
      { text: "Location", value: "location", width: "30%" },
      { text: "Monto", value: "amount", width: "15%" },
      { text: "Acciones", value: "actions", width: "5%", sortable: false },
      { text: "", value: "data-table-expand" }
    ],
    accounts_update: [],
    itemsDepartment: [],
    categoryDgii: [],
    accounts: [],
    categories: [],
    accounts_computed: [],
    entity: [],
  }),

  computed: {
    formattedAmount() {
      const amount = this.calculateAdjustedAmount();
      return this.currencyFormat(amount*this.item.quantity);
    },
    totCont() {
      let totalAmount = this.accounts_computed.reduce((sum, account) => sum + parseFloat(account.amount  || 0), 0);
      return { totalAmount };
    },
  },

  watch: {
    'item.accountable'(val) {
      this.$emit('accountable', { status: val, item_id: this.item.id });
    },
    seleted_currencies: {
      handler(newVal) {
        this.updateAccountAmounts(newVal);
      },
      immediate: true
    }
  },

  created() {
    this.getData();
  },

  methods: {
 
    async getEntitys(name) {
      this.entity = [];
      const responseRequest = await this.api_Post("accounting/search_entity", {
        name: name,
        type: "",
        all:false
      });
      if (responseRequest.ok) {
        const data = await responseRequest.json();
        this.entity = data.map(item => ({ text: item.name, value: item.entity_id }));
      }
    },
    async getData() {
      this.accounts_update = this.item;
      const [categories, accounts, categoryDgii] = await Promise.all([
        this.fetchCategories(),
        this.fetchAccounts(),
        this.fetchCategoryDgii()
      ]);

      this.categories = categories;
      // Las cuentas de sistema solo se usan en entradas de diario: se muestran pero no se pueden elegir
      this.accounts = accounts.map(element => ({
        name: `${element.code} - ${element.name}${element.is_system_only ? " (sistema)" : ""}`,
        id: element.id,
        disabled: !!element.is_system_only
      }));
      this.categoryDgii = categoryDgii.map(item => ({ text: item.name, value: item.id }));
      this.itemsDepartment = await this.g_departments();
     
      // Asignar un ID único a cada elemento para que item-key funcione correctamente
      this.accounts_computed = this.item.accounts_edited.map((account, index) => ({
        ...account,
        id: account.id || `acc_${Date.now()}_${index}`, // Usar ID existente o generar uno nuevo
        amount: parseFloat(account.amount)*parseFloat(this.item.quantity),
        location_id: this.selected_locations.value
      }));
    },
    async fetchCategories() {
      const response = await this.api_Get("accounting/categories_diary_book");
      return response.json();
    },
    async fetchAccounts() {
      const response = await this.api_Get("accounting/accountsUsable");
      return response.json();
    },
    async fetchCategoryDgii() {
      const response = await this.api_Get("accounting/category_dgii");
      return response.json();
    },
    deleteItem(item) {
      const index = this.accounts_computed.findIndex(account => account.id === item.id);
      if (index !== -1) {
        this.accounts_computed.splice(index, 1);
      }
    },
    close() {
      this.$emit("close");
    },
    save() {
      if (!this.validateAccounts()) {
        return;
      }
      const data = {
        accounts: this.accounts_computed,
        item_id: this.item.item_id,
        item_description: this.item.item_description,
        note: this.item.note
      };
     
      this.$emit("saveAccount", data);
    },
    validateAccounts() {
      const invalidAccounts = this.accounts_computed.some(account => 
        !account.chart_of_account_id || account.chart_of_account_id === ''
      );
      if (invalidAccounts) {
        this.$toast.warning("La cuenta es obligatoria para todas las líneas");
        return false;
      }
      return true;
    },
    addLine() {
      const newAmount = Math.max(0, this.item.amount - this.totCont.totalAmount);
      // Generar un ID realmente único con prefijo, timestamp y contador
      this.accounts_computed.push({
        id: `acc_${Date.now()}_${this.accounts_computed.length}`,
        is_new: true,
        entry_type_id: this.accounts_computed[0]?.entry_type_id,
        chart_of_account_id: "",
        categoryDgii: "",
        descripcion: "",
        debito: "",
        credito: "",
        amount: newAmount,
      });
    },
    updateAccountAmounts(currencyId) {
      this.accounts_computed.forEach(account => {
        const currencyData = this.item.item_currencies.find(c => c.currency_id == currencyId);
        if (currencyData) {
      
          if (this.type === 1) {
            account.amount = parseFloat(currencyData.cost_price);
          } else if (this.type === 2) {
            let price_sale = parseFloat(currencyData.sale_price);
            if (this.hasDiscount) {
              price_sale -= price_sale * (this.discount_percent_selected / 100);
            }
            account.amount = price_sale;
          }
        }
      });
    },
    calculateAdjustedAmount() {
      const baseAmount = parseFloat(this.item.amount);
      if (this.hasDiscount) {
        return baseAmount - (baseAmount * (this.discount_percent_selected / 100));
      }
      return baseAmount;
    },
    updateDgiiCategory(item) {
      const selectedAccount = this.accounts.find(account => account.id === item.chart_of_account_id);
      if (selectedAccount) {
        item.dgii_category_id = selectedAccount.dgii_category_id;
      }
      this.resetInvalidAccountCategory(item, this.categories, item.chart_of_account_id, 'diary_book_category_id', 'diary_book_sub_category_id');
    },
    filteredSubCategories(item) {
      return this.subcategoriesForAccount(this.categories, item.chart_of_account_id, item.diary_book_category_id);
    },
  },
};
</script>

<style scoped>
.v-data-table ::v-deep .v-data-table__expanded__content {
  box-shadow: inset 0 4px 4px -4px rgba(0, 0, 0, 0.1), inset 0 -4px 4px -4px rgba(0, 0, 0, 0.1);
}
</style>